'use client';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import PublicNav from '@/components/PublicNav';
import LandingHero from '@/app/components/LandingHero';
import LandingHowItWorks from '@/app/components/LandingHowItWorks';
import LandingCategories from '@/app/components/LandingCategories';
import LandingForBusiness from '@/app/components/LandingForBusiness';
import LandingFooter from '@/app/components/LandingFooter';
import { useAuth } from '@/contexts/AuthContext';

export default function HomePage() {
  const { user, loading, getUserProfile } = useAuth();
  const router = useRouter();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (loading) return;

    if (!user) {
      setChecking(false);
      return;
    }

    // User is logged in — fetch their role and redirect
    getUserProfile()
      .then((profile: any) => {
        if (profile?.role === 'business') {
          router.replace('/business-dashboard');
        } else {
          router.replace('/customer-home-discover');
        }
      })
      .catch(() => {
        // If profile fetch fails, just show the landing page
        setChecking(false);
      });
  }, [user, loading]);

  // While auth is being determined, show nothing (or a minimal loader)
  if (loading || (user && checking)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-8 h-8 border-4 border-[#FF6B35] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <PublicNav />
      <main className="flex-1">
        <LandingHero />
        <LandingHowItWorks />
        <LandingCategories />
        <LandingForBusiness />
      </main>
      <LandingFooter />
    </div>
  );
}